export default "__VITE_ASSET__FpEB1v3P__"